import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import {LoadingButton} from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';

interface AutomationDeleteDialogProps {
    open: boolean;
    name: string;
    isDeleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const AutomationDeleteDialog: React.FC<AutomationDeleteDialogProps> = ({
    open,
    name,
    isDeleting,
    onClose,
    onConfirm
}) => {
    const {t} = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{sx: {minWidth: 360, maxHeight: '90vh'}}}
        >
            <DialogTitle sx={{pb: 1}}>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={1}>
                    <Typography variant={'h6'} fontWeight={600} noWrap>
                        {t('Delete automation')}
                    </Typography>

                    <Tooltip title={t('Close')}>
                        <IconButton onClick={onClose} size={'small'} aria-label={t('Close')}>
                            <CloseIcon/>
                        </IconButton>
                    </Tooltip>
                </Stack>
            </DialogTitle>

            <DialogContent dividers>
                <DialogContentText>
                    {t('The automation "{{name}}" and its configuration will be deleted. Past runs stay in the history.', {name})}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    {t('Cancel')}
                </Button>
                <LoadingButton
                    variant={'contained'}
                    color={'error'}
                    loading={isDeleting}
                    onClick={onConfirm}
                >
                    {t('Delete')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default AutomationDeleteDialog;
